import _ from 'lodash';

import i18n from 'scripts/i18n/i18n';

// `optionIds` are topic ids; `attributeValues` are freeform topics, each a custom attribute id
// plus the value an agent typed. `findOption` resolves either kind to `{ name, disabled }`.
export default function getSelectedTopicLabels({ attributeValues, findOption, optionIds }) {
  const topicLabels = _.compact(_.map(optionIds, id => findOption(id)?.name));

  const attributeLabels = _.compact(
    _.map(attributeValues, ({ id, value }) => {
      const option = findOption(id);
      if (!option) {
        return null;
      }

      const archived = option.disabled ? ` ${i18n.t('(Archived)')}` : '';
      return `${option.name} > ${value}${archived}`;
    })
  );

  return _.sortBy([...topicLabels, ...attributeLabels], label => label.toLowerCase());
}
